module.exports = __webpack_public_path__ + "img/mesa_hl26.d40cd725.png";